<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { Search as SearchIcon, Moon as MoonIcon, Sunny as SunnyIcon } from '@element-plus/icons-vue'
import LangSet from './components/LangSet.vue'
import { useThemeConfig } from '@/hooks/useThemeConfig'
import { useRouter } from 'vue-router'
import { useUserStoreHook } from '@/store/modules/user'
import UserCard from './components/UserCrad.vue'
import { Navigation } from '@/utils/navigation'
const { locale, t } = useI18n()
const route = useRoute()
const router = useRouter()

// 菜单项
const menuItems = [
  { path: '/home', title: 'home' },
  { path: '/music', title: 'music' },
  { path: '/voice', title: 'voice' },
  { path: '/ai', title: 'ai' },
  { path: '/mv/edit/list', title: 'mv' },
  { path: '/space', title: 'space' },
  // { path: '/mv', title: 'mv' },

  // { path: '/about', title: 'about' },
]

// 导航栏背景单独处理路由
const bgMenus29 = ['/mv/edit', '/mv/edit/list']

// 当前激活的菜单
const activeMenu = computed(() => {
  // 处理带有参数的路由，如/mv/edit/:projectId
  if (route.path.startsWith('/mv/edit/')) {
    return '/mv/edit'
  }
  return route.path
})

// 搜索
const searchText = ref('')
const { currentTheme, updateTheme } = useThemeConfig()

const handleLogin = () => {
  router.push('/login')
}

// 处理主题切换
const handleThemeChange = (theme: 'default' | 'dark') => {
  updateTheme(theme)
}

const handleCommand = (command: string | number | object) => {
  console.log(command, 'command')
  if (command === 'logout') {
    console.log('退出登录')
    useUserStoreHook().logOut()
  }
  if (command === 'admin') {
    // router.push('/admin/user')
    const route = router.resolve({
      name: 'adminUser',
    })
    Navigation.openBlank(route.href)
  }
}
const handleHome = () => {
  router.push('/home')
}
</script>

<template>
  <header
    class="fixed top-0 left-0 right-0 h-[60px] z-50"
    :class="
      bgMenus29.includes(activeMenu) || route.path.startsWith('/mv/edit/')
        ? '!bg-[#1f2229]'
        : 'bg-menu-bg shadow-md'
    "
  >
    <div class="px-[60px] mx-auto h-full flex items-center justify-between">
      <!-- 左侧 -->
      <div class="flex items-center space-x-[1.25rem] animate__animated animate__backInLeft">
        <!-- Logo -->
        <!-- <img
          :src="$imageUrl('/assets/logo/logo.png')"
          alt="logo"
          class="w-[4.75rem] object-cover"
          @click="handleHome"
        /> -->
        <img
          src="@/assets/icon/logo.png"
          alt="logo"
          class="w-[176px] object-cover"
          @click="handleHome"
        />
        <!-- 搜索框 -->
        <!-- <div class="relative w-[12rem]">
          <el-input
            v-model="searchText"
            :placeholder="t('menus.searchPlaceholder')"
            class="!rounded-full !text-[size12] overflow-hidden custom-input"
          >
            <template #suffix>
              <el-icon class="text-gray-400"><SearchIcon /></el-icon>
            </template>
          </el-input>
        </div> -->
      </div>
      <!-- 中间导航 -->
      <div class="flex items-center animate__animated animate__backInRight">
        <nav class="flex-1 flex justify-end">
          <el-menu
            :default-active="activeMenu"
            mode="horizontal"
            :ellipsis="false"
            router
            class="!border-none !bg-transparent flex-1 flex justify-end"
          >
            <el-menu-item
              v-for="item in menuItems"
              :key="item.path"
              :index="item.path"
              class="!text-menu-text !hover:text-menu-active !border-none !text-size16 font-roboto !mr-[1rem] lg:!mr-[2rem] !px-[0]"
            >
              {{ t(`menus.${item.title}`) }}
            </el-menu-item>
          </el-menu>
        </nav>
        <!-- 右侧功能区 -->
        <div class="flex items-center ml-[1.25rem]">
          <!-- 登录/注册按钮 -->
          <el-button
            type="primary"
            class="!bg-white !text-[#0770ED] hover:!bg-opacity-90 !border-none !rounded-full !text-size14 !h-[2rem] flex items-center justify-center !px-[12px] pl-[.375rem]"
            @click="handleLogin"
            v-if="!useUserStoreHook().isLogin"
          >
            {{ t('formOrTips.loginOrRegister') }}
          </el-button>
          <UserCard v-else />
          <!-- 语言切换 -->
          <!-- <LangSet /> -->
          <!-- 主题切换 -->
          <!-- <el-dropdown @command="handleThemeChange" class="ml-[.75rem]">
            <el-button class="!bg-transparent !border-none">
              <el-icon class="text-[20px]" color="#fff">
                <component :is="currentTheme === 'default' ? SunnyIcon : MoonIcon" />
              </el-icon>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item command="default">{{ t('menus.theme') }}</el-dropdown-item>
                <el-dropdown-item command="dark">{{ t('menus.dark') }}</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown> -->
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
:deep(.el-menu--horizontal .el-menu-item) {
  &:not(.is-disabled):focus,
  &:not(.is-disabled):hover {
    background-color: transparent;
  }

  &:hover {
    background-color: var(--menu-menubBg) !important;
    color: var(--menu-subMenuActiveText) !important;
  }

  &.is-active {
    color: var(--menu-subMenuActiveText) !important;
    font-size: var(--text-size-18) !important;
    background-color: transparent !important;
  }
}
:deep(.el-input) {
  .el-input__wrapper {
    background-color: rgba(255, 255, 255, 0.5) !important;
    box-shadow: none !important;
    padding: 0 16px !important;
    border-radius: 9999px !important;
    height: 2rem !important;

    &.is-focus {
      box-shadow: none !important;
    }

    input {
      color: #fff !important;
      background: transparent !important;
      height: 2rem !important;

      &::placeholder {
        color: rgba(255, 255, 255, 0.8) !important;
        font-size: var(--text-size-14) !important;
      }
    }
  }

  .el-input__suffix {
    .el-icon {
      color: rgba(255, 255, 255, 0.8) !important;
    }
  }
}
</style>
